import { styled } from '@mui/material';
import { colorPalettes } from '../../../../context/theme';
import { LINE_HEIGHT, SIZES } from '../../../../constants/sizes';

export const StyledAvatar = styled.div`
  background-color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.avatar
      .background};
  border-radius: 50%;
  cursor: pointer;
  height: 2.8rem;
  width: 2.8rem;
  justify-content: center;
  display: flex;
  align-content: center;
  align-items: center;
  position: relative;
`;

export const StyledAvatarName = styled.span`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.avatar.text};
  font-weight: 700;
  font-size: ${SIZES['medium']};
  line-height: ${LINE_HEIGHT['x-medium']};
  cursor: pointer;
`;

export const StyledAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;
